import React, { useState, useEffect, useCallback } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, PieChart, Pie, Cell } from 'recharts';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import getStats from 'utils/getStats';
import Cookies from 'js-cookie';

import './Chart.css';

// Colors for pie chart
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const Chart = () =>  {
    const [data1, setData1] = useState([]);
    const [data2, setData2] = useState([]);
    const [data3, setData3] = useState([]);
    const [filter, setFilter] = useState("All");
    const [anchorEl, setAnchorEl] = React.useState(null);
  
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = (value) => {
      setFilter(value);
      setAnchorEl(null);
    };


    const refreshData = useCallback(async () => {
      try {
        const jwt = Cookies.get('_auth'); 
        console.log('Stats JWT: ' + jwt)
        const res = await getStats(jwt, filter);
        console.log('Charts: result from stats utilities: ' + JSON.stringify(res.data))
        setData1(res.data.map(item => ({name: item.date, contacts: item.contacts})));
        setData2(res.data.map(item => ({name: item.date, messages: item.messages})));
      } catch (err) {
        console.error(err);
      }
    }, [filter]);
    
  
    useEffect(() => {
      refreshData();
    }, [refreshData]);
  
    useEffect(() => {
      console.log('data2 is updated', data2);
    }, [data2]);

  return (
    <div className="ChartContainer">
         <div style={{display: "flex", justifyContent: "flex-end", marginBottom: "20px"}}>
        <span style={{marginRight: "10px", alignSelf: "center"}}>Filter: {filter}</span>
        <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
          <FilterListIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => handleClose(filter)}
        >
          <MenuItem onClick={() => handleClose('Cal')}>Cal</MenuItem>
          <MenuItem onClick={() => handleClose('Pais')}>Pais</MenuItem>
          <MenuItem onClick={() => handleClose('IDI')}>IDI</MenuItem>
          <MenuItem onClick={() => handleClose('All')}>All</MenuItem>
        </Menu>
        <IconButton onClick={refreshData}>
          <RefreshIcon />
        </IconButton>
      </div>
      
      <div className="BarContainer">
        <div className="ChartWrapper">
          <h2>לקוחות</h2>
          <BarChart
            width={500}
            height={300}
            data={data1}
            margin={{
              top: 5, right: 30, left: 20, bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="contacts" fill="#8884d8" />
          </BarChart>
        </div>
        <div className="ChartWrapper">
          <h2>הודעות</h2>
          <BarChart
            width={500}
            height={300}
            data={data2}
            margin={{
              top: 5, right: 30, left: 20, bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="messages" fill="#82ca9d" />
          </BarChart>
        </div>
      </div>
      <div className="ChartWrapper">
        <h2>Attraction Names</h2>
        <PieChart width={600} height={600}>
          <Pie
            data={data3}
            cx={300}
            cy={300}
            labelLine={false}
            outerRadius={180}
            fill="#8884d8"
            dataKey="value"
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          >
            {
              data3.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
            }
          </Pie>
          <Tooltip />
        </PieChart>
      </div>
    </div>
  );
};

export default Chart;
